const awsConfig = {
  identityPoolId: "eu-central-1:0ae4627b-6ed8-439f-8dd9-3ae169e2a9ad",
  region: "eu-central-1",
  userPoolId: "eu-central-1_Y12DpSWop",
  userPoolWebClientId: "6fu7vdvnt8v5qaqf2d6ov35tbc",
};

export default awsConfig;
